import NTFooter from "./NTFooter";

export default NTFooter;
